
<!--<app-alerts></app-alerts>-->
<main>
  <section>
    <div class="container-fluid ptb-42">
      <div class="row">
        <div class="col-auto">
          <div class="titles-bdr-r">
            <h1 class="color-primary fs-325remTitles">{{'navLinks.horarios' | translate}}</h1>
          </div>
        </div>
      </div>
    </div>
  </section>
  <section>
    <div class="container pb-120 gx-5 gx-lg-0 horariosPage">
      <!-- Filtros -->
      <div class="row justify-content-center mb-4 horariosFiltersBlock">
        <div class="col-lg-11 col-12 p-3 bg-secondary bdr-r-10 gx-5">
          <form [formGroup]="searchForm" *ngIf="searchForm">
            <div class="row">
              <div class="col-lg col-12">
                <label aria-label="Município" class="mb-1 color-white">{{'formLabels.municipio' | translate}}</label>
                <select aria-label="Selecionar Município" formControlName="municipality" class="form-select">
                  <option value="" disabled selected hidden>{{'formPlaceholders.selecionar' | translate}}</option>
                  <option *ngFor="let municipality of municipalities" value="{{municipality.code}}">{{municipality.name}}</option>
                </select>
              </div>
            </div>
          </form>
        </div>
      </div>
      <div *ngFor="let route of routes" class="row p-md-4 px-0 justify-content-center mb-3 mb-md-0">
        <div class="col-lg-11 col-12 p-0 id-linha d-flex flex-wrap align-items-center">
          <div class="col-auto d-flex align-items-center">
            <span class="badge uppercase-font fs-28px" [ngStyle]="{'background-color': route.color}">{{ route.number }}</span>
          </div>
          <div class="col-12 col-md d-flex align-items-center order-3 order-md-2 mt-2 mt-md-0">
            <i class="uil uil-angle-right-b fs-2rem"></i>
            <h5 class="horarios-linhas-nomes m-0">{{ route.name }}</h5>
          </div>
          <div class="col-auto d-flex align-items-center ms-auto order-2 order-md-3">
            <button title="Download PDF" type="button" class="btn btn-outline-secondary btn-download" aria-pressed="true" (click)="downloadPdf(route.number)">
              <p class="m-0 fs-12px fw-700 line-height-1-2">{{ 'buttons.downloadSchedule' | translate }}<i class="uil uil-file-download-alt fs-20px ms-2"></i></p>
            </button>
          </div>
        </div>
      </div>
    </div>
  </section>
</main>

